export {
    dateProps
  }
  
  let rangePickerOptions = {
    disabledDate,
    shortcuts: [
      {
        text: '昨天',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: '过去7天',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: '过去14天',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(end.getTime() - 3600 * 1000 * 24 * 14);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          picker.$emit('pick', [start, end]);
        }
      },
      {
        text: '过去30天',
        onClick(picker) {
          const end = new Date();
          const start = new Date();
          start.setTime(end.getTime() - 3600 * 1000 * 24 * 30);
          end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
          picker.$emit('pick', [start, end]);
        }
      },
    ]
  };
  
  function getCurrentMonthFirst(){
    let date = new Date();
    date.setDate(1);
    return date;
  }
  
  function disabledDate(date) {
    const cur = new Date();
    cur.setHours(0);
    cur.setMinutes(0);
    cur.setSeconds(0);
    cur.setMilliseconds(0);
    let dateMin = new Date(cur.getTime() - 3600 * 1000 * 24 * 100);
    return date >= cur 
    || date < dateMin;
  }
  
  let dateProps = {
    'value-format': 'yyyy-MM-dd',
    'type': 'daterange',
    'picker-options': rangePickerOptions,
    'range-separator': '至',
    'start-placeholder': '开始日期',
    'end-placeholder': '结束日期'
  };